import makeStyles from "e100-react-components/lib/styles/makeStyles";

export const useStyles = makeStyles(({ spacing }) => ({
  addressContainer: {
    maxWidth: "210px",
    minHeight: spacing(3),
  },
}));
